import React from 'react';
import { Table } from 'tea-component';
import { useIntl, getLocale } from 'umi';
import CommonBubble from '@home/components/CommonBubble';

// import ComponentProxy from '@dashboard/components/Navigation/GameSelector/components/ComponentProxy'
import './index.scss';
import { ILeftTable } from './_type';
import ComponentProxy from '../../../../components/Navigation/GameSelector/components/ComponentProxy';

// 弹框
const { selectable, autotip } = Table.addons;

const LeftTable = (props: ILeftTable) => {
  const { formatMessage } = useIntl();
  const isEN = getLocale() === 'en-US';
  const { dataSource, selectedIdList, onChange, loading, columns, maxSelected } = props || {};

  return (
    <ComponentProxy
      loading={loading}
      noData={dataSource?.filter((item: any) => !item?.isTitleRow).length === 0}
      height={'100%'}
      noDataText={isEN ? 'No result found' : '无匹配项'}
      componentRender={() => (
        <Table
          className='dbd-left-table'
          records={loading ? [] : dataSource}
          recordKey="game_id"
          hideHeader={true}
          columns={columns}
          rowClassName={(record: any) => record?.isTitleRow ? 'table-row-title' : 'table-row'}
          rowDisabled={(record) =>
            (selectedIdList?.length >= maxSelected &&
              !selectedIdList.includes(record.game_id))
            || record?.isTitleRow
          }
          addons={[
            autotip({
              isLoading: loading,
              loadingText: '',
            }),
            selectable({
              value: selectedIdList,
              onChange,
              rowSelect: true,
              render: (ele, { disabled, record }: any) => {
                return record?.isTitleRow ? (
                  <></>
                ) : (
                  <CommonBubble
                    dark
                    closeOnScroll
                    content={
                      disabled
                        ? formatMessage({ id: 'benchmark_you_can_choose_up_to_9_games' }, { num: maxSelected })
                        : ''
                    }
                  >
                    {ele}
                  </CommonBubble>
                );
              },
            }),
          ]}
        />
      )}
    />
  );
};

export default LeftTable;
